import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";
const Main = lazy(
  () =>
    import("../../../components/settings/certificate/assignSignatoryType/main")
);

const AssignSignatoryType = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default AssignSignatoryType;
